import { colors } from '../theme';

export const modalStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: colors.overlay,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '1.25rem',
    backdropFilter: 'blur(12px)',
    zIndex: 1200
  },
  modal: {
    background: 'linear-gradient(180deg, rgba(24,30,28,0.98), rgba(16,20,19,0.98))',
    padding: '1.4rem',
    borderRadius: '18px',
    width: '90%',
    maxWidth: '760px',
    maxHeight: 'calc(100vh - 2.5rem)',
    overflowY: 'auto',
    color: colors.textStrong,
    textAlign: 'left',
    border: `1px solid ${colors.panelBorder}`,
    boxShadow: colors.shadow
  },
  input: {
    width: '100%',
    padding: '0.8rem 0.95rem',
    marginTop: '0.75rem',
    marginBottom: '0.9rem',
    fontSize: '1rem',
    borderRadius: '12px',
    border: `1px solid ${colors.panelBorder}`,
    backgroundColor: 'rgba(255,255,255,0.04)',
    color: colors.textStrong
  },
  button: {
    background: colors.accent,
    color: '#11201c',
    border: 'none',
    padding: '0.8rem 1.2rem',
    fontSize: '1rem',
    cursor: 'pointer',
    borderRadius: '999px',
    fontWeight: 700
  },
  buttonAlt: {
    background: 'rgba(255,255,255,0.06)',
    color: colors.textStrong,
    border: `1px solid ${colors.panelBorder}`,
    padding: '0.8rem 1.2rem',
    fontSize: '1rem',
    marginLeft: '0.75rem',
    borderRadius: '999px',
    fontWeight: 700,
    cursor: 'pointer'
  }
};
